import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { reset, clearSubmitErrors } from 'redux-form';
import List from './List';
import Filter, { selector as FilterSelector, PeriodTypes } from './Filter';
import {
	loadRoyaltyReport, exportRoyaltyReport, exportRoyaltyPayments,
	ROYALTY_REPORT_EXPORT_REQUEST, ROYALTY_REPORT_EXPORT_SUCCESS, ROYALTY_REPORT_EXPORT_FAILURE
} from './actions';
import { initialize } from 'redux-form';
import XeroInputDataDialog from './XeroInputDataDialog';
import utils from '../../../common/services/utils';
import moment from 'moment';

class RoyaltyReport extends Component {

	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleTermSelected = this.handleTermSelected.bind(this);
		this.handleXeroInputDataDialogConfirm = this.handleXeroInputDataDialogConfirm.bind(this);
		this.showXeroInputDataDialog = this.showXeroInputDataDialog.bind(this);
		this.hideXeroInputDataDialog = this.hideXeroInputDataDialog.bind(this);
		this.state = {
			termId: null,
			showXeroInputDataDialog: false
		};
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		if (filter && filter.termId) {
			filter.periodType = PeriodTypes.TERM;
			this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
			this.setState({ termId: filter.termId });
		}
		this.props.initializeFilter(filter);
	}

	handleTermSelected(termId) {
		// trigger filter on initial load when Active Term is selected by default in the dropdown
		if (this.state.termId === null) {
			const { filter } = this.props.pagination;
			if (!filter.termId) {
				filter.periodType = PeriodTypes.TERM;
				filter.termId = termId;
				this.props.initializeFilter(filter);
			}

			this.loadData({ ...this.props.pagination, filter: { ...filter } });
		}
		this.setState({ termId });
	}

	handleFilterSubmit(options) {
		const { exportFormat, ...filter } = options;
		const { sortKey, sortDirection, pageSize } = this.props.pagination;
		let searchParams = this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
		if (exportFormat) {
			this.exportData(searchParams, exportFormat);
		}
	}

	exportData(filter, exportFormat) {
		switch (exportFormat) {
			case 'Excel':
				this.props.exportRoyaltyReport(exportFormat, filter, {});
				break;
			case 'Xero':
				this.showXeroInputDataDialog();
				break;
			case 'Payments':
				this.props.exportRoyaltyPayments(filter);
				break;
		}
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		const { loadReport } = this.props;
		this.props.clearSubmitErrors();
		if (filter) {
			const { periodType, termId, year, month, startDate, endDate, ...rest } = filter;

			let searchParams = { periodType, year, month, ...rest };
			switch (periodType) {
				case PeriodTypes.TERM:
					searchParams = Object.assign(searchParams, { termId });
					break;
				case PeriodTypes.MONTH:
					const startOfMonth = moment([year, Number(month) - 1]);
					const endOfMonth = startOfMonth.clone().endOf('month');
					searchParams = Object.assign(searchParams, { startDate: startOfMonth.toDate(), endDate: endOfMonth.toDate() });
					break;
				case PeriodTypes.DATE:
					searchParams = Object.assign(searchParams, { startDate, endDate });
					break;
			}

			loadReport({ ...searchParams, sortKey, sortDirection, pageSize, pageNumber });
			return searchParams;
		}
	}

	handleXeroInputDataDialogConfirm(values) {
		this.props.exportRoyaltyReport('Xero', this.props.pagination.filter, values, response => {
			this.hideXeroInputDataDialog();
		});
	}

	showXeroInputDataDialog() {
		this.setState({
			showXeroInputDataDialog: true
		});
	}

	hideXeroInputDataDialog() {
		this.setState({
			showXeroInputDataDialog: false
		});
	}

	render() {
		const { data, months, years, periodType, bookingTypes } = this.props;

		return (
			<div>
				<Filter
					onSubmit={this.handleFilterSubmit}
					onTermSelected={this.handleTermSelected}
					months={months}
					years={years}
					periodType={periodType}
					bookingTypes={bookingTypes}
					loading={this.props.pagination.loading || this.props.export.loading || this.props.exportPayments.loading}
				/>
				<List
					data={data}
					onFetchData={this.handleListEvent}
					{...this.props.pagination}
				/>
				<XeroInputDataDialog show={this.state.showXeroInputDataDialog}
					block={ROYALTY_REPORT_EXPORT_REQUEST}
					unblock={[ROYALTY_REPORT_EXPORT_SUCCESS, ROYALTY_REPORT_EXPORT_FAILURE]}
					onConfirm={this.handleXeroInputDataDialogConfirm}
					onCancel={this.hideXeroInputDataDialog} />
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		pagination,
		exports,
		entities: { royaltyReport, terms },
		lookups: { years, months, bookingTypes }
	} = state;

	const royaltyReportPagination = pagination.royaltyReport.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const royaltyReportExport = exports.royaltyReport.all || {};
	const royaltyPaymentsExport = exports.royaltyReportPayments.all || {};

	royaltyReportPagination.filter = Object.assign({
		year: utils.getCurrentYear(),
		month: utils.getCurrentMonth(),
		periodType: PeriodTypes.TERM,
		bookingType: 1//Lessons
	}, royaltyReportPagination.filter);

	return {
		data: royaltyReportPagination.ids.map(id => royaltyReport[id]),
		pagination: royaltyReportPagination,
		export: royaltyReportExport,
		exportPayments: royaltyPaymentsExport,
		months,
		years,
		periodType: FilterSelector(state, 'periodType'),
		bookingTypes,
		bookingType: FilterSelector(state, 'bookingType'),
		terms
	};
};

const mapDispatchToProps = {
	loadReport: loadRoyaltyReport,
	exportRoyaltyReport,
	exportRoyaltyPayments,
	clearSubmitErrors: () => clearSubmitErrors('royaltyReportFilter'),
	resetFilter: () => reset('royaltyReportFilter'),
	initializeFilter: (data, fields) => initialize('royaltyReportFilter', data, fields)
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RoyaltyReport));